<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "Invite",
        components: {CommonTable},
        data() {
            return {
                searchs:[

                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },{
                        name: 'inviteCode',
                        placeholder: '邀请码',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '订单状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '禁用'
                        },{
                            key: 1,
                            value: '启用'
                        }]
                    },
                    /*{
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }*/
                ],
                permission:{
                    add: 'invite:add',
                    update: 'invite:update',
                    delete: 'invite:delete',
                    deleteBatch: 'invite:deleteBatch'
                },
                url: {
                    get: '/invite/listByCondition',
                    add: '/invite/add',
                    update: '/invite/update',
                    delete: '/invite/delete',
                    delete_batch: '/invite/deleteBatch',
                    status: '/invite/status'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'userId',
                    label: '用户ID',
                    show: false,
                    width: '75',
                }, {
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                }, {
                    field: 'ratio',
                    label: '佣金比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                }, {
                    field: 'inviteCode',
                    label: '邀请码',
                    show: true,
                }, {
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '禁用',
                        },{
                            key: 1,
                            value: '启用',
                        }]
                    },
                    status: true,
                }],
                formFields: {
                    updateTitle: '修改邀请码',
                    labelWidth: '90px',
                    model: [{
                        field: 'userId',
                        label: '用户ID：',
                        type: 'select',
                        selectUrl: '/userInfo/getAll',
                        selectData: [],
                        placeholder: '用户ID',
                        rules:[{
                            message: '请输入用户ID', trigger: 'blur', required: true
                        }],
                        filterable: true,
                        add: true,
                        update: true,
                    }, {
                        field: 'userNick',
                        label: '用户昵称：',
                        type: 'input',
                        placeholder: '用户昵称',
                        rules:[{
                            message: '请输入昵称', trigger: 'blur', required: true
                        }],
                        add: false,
                        update: false
                    }, {
                        field: 'ratio',
                        label: '佣金比例：',
                        type: 'number',
                        placeholder: '佣金比例',
                        rules:[{
                            message: '请输入佣金比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    }/*, {
                        field: 'inviteCode',
                        label: '邀请码：',
                        type: 'input',
                        placeholder: '邀请码',
                        rules:[{
                            message: '请输入邀请码', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true
                    }*/]
                }
            }
        },
    }
</script>

<style scoped>

</style>
